import { css } from '@emotion/react';

export const groupHeader = css`
  position: fixed;
  width: 100%;
  z-index: 10;
`;

export const root = css`
  display: grid;
  grid-template-columns: 200px auto 250px;
  align-items: center;
  height: 82px;
  padding: 0 2.4rem 0 2.4rem;
  /* position: sticky; */
  /* top: 0;
  left: 0; */
  width: 100%;
  z-index: var(--zindex-header);
  background: var(--color-white);
  border-bottom: 1px solid #ececef;
`;

export const title = css`
  width: 167px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const schoolname = css`
  font-size: 12px;
  margin-top: 7px;
  text-align: center;
`;

export const navigation = css`
  display: flex;
  justify-content: flex-start;
  height: inherit;
  overflow: auto;
`;

export const divider = css`
  width: max-content;
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  border-left: 1px solid #e5e5e5;
`;

export const link = css`
  display: inline-flex;
  align-items: center;
  height: 100%;
  padding: 0rem 1.2rem;
  min-width: 7rem;
  justify-content: center;
  border-bottom: 0.4rem solid transparent;
  font-size: 1.4rem;
  font-weight: 700;
  transition: background-color 0.3s linear;

  &:hover {
    background-color: var(--color-background-light);
    color: inherit;
    text-decoration: inherit;
  }

  /* @media only screen and (max-width: 1557px) {
    font-size: 1.3rem;
  } */
`;

export const accountSettingLink = css`
  &:hover {
    color: inherit;
    text-decoration: inherit;
  }
`;

export const logoutBtn = css`
  color: var(--color-text-default);
`;

export const current = css`
  border-bottom-color: var(--color-primary-default);
`;

export const tools = css`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 2.4rem;
`;

export const open = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.8rem;
  height: 4.8rem;
  border: 1px solid var(--color-foreground-sub);
  border-radius: 0.4rem;
`;

export const account = css`
  position: relative;
`;

export const trigger = css`
  display: flex;
  align-items: center;
`;

export const arrow = css`
  display: block;
  padding-left: 0.5rem;
`;

export const tooltip = css`
  min-width: 19.6rem;
  background: var(--color-background-light);
  border-radius: 0.8rem;
  position: absolute;
  top: calc(100% + 0.6rem);
  right: 0;
  white-space: nowrap;
  box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  transition: transform 0.45s var(--ease-out), opacity 0.45s var(--ease-out);
  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transform: translate3d(0, -10px, 0);
  }
  > a {
    display: block;
    padding: 1em;
    border-bottom: 1px solid var(--color-foreground-light);
  }
  > button {
    display: block;
    padding: 1em;
  }
`;

export const faq = css`
  text-decoration: underline;
  color: #303033;
  font-weight: 700;
  :hover {
    color: #303033;
  }
`;
